














































































































































































import Vue from 'vue';
import { Component, Prop } from "vue-property-decorator";
import HeaderComponents from "../../../../../Assets/Card/Header/Header.vue";
import BodyComponents from "../../../../../Assets/Card/Body/Body.vue";
import FooterComponents from "../../../../../Assets/Card/Footer/Footer.vue";
import Notify from "@/components/App/Assets/Notify/Notify.vue";
import './style/nestedtable.scss';
import { parseInt } from 'lodash';
import { Notification, INotification } from "@/entities";
/**
 * Component's properties and events
 */
@Component({
    components: {
        BodyComponents,
        FooterComponents,
        HeaderComponents,
        Notify,
        Dialog: () => import("@/components/common/Dialog/DialogComponent.vue")
    }
})

export default class extends Vue {
    dialog: boolean = false;
    confirmDialog: boolean = false;
    confirmText: string = "";
    currentAction: string = "Add";
    actionType = {
        Add: 'Add',
        Edit: 'Edit',
        Delete: 'Delete',
    }
    action: string = "";
    loading: boolean = false;
    isChildAction: boolean = false;
    parentIndex: number = null;
    editedIndex = -1;
    editedItem: any = {};
    parentSection: any = {};
    dropdowns: any = {};
    checklist: any = [];
    resetKey = 0;

    mounted() {
        this.dropdowns.widgets = [
            { Id: 'checklist', Name: "Checklist Section" },
            { Id: 'document_upload', Name: "Document Upload Section" }
        ];

        this.populateDropdowns();
        this.list();
    }

    // Get dialog form title
    get formTitle() {
        return this.isChildAction
            ? this.$t(`${this.action} checklist`)
            : this.$t(`${this.action} section`);
    }

    get dialogActions() {
        return [{ event: "save", text: this.currentAction },
        { event: "close", text: "Close" }];
    }

    // Get dropdown items
    populateDropdowns() {
        let callId = parseInt(this.$store.state.dashboard.componentId);

        return this.$services.callChecklist.populateDropdowns(callId).then((resp) => {
            this.dropdowns.data = resp;
            this.dropdowns.sections = resp.Sections;
            this.dropdowns.fields = [];
        });
    }

    // Filter items based on the sections
    filterFields(key: string) {
        // Filter calls by section
        this.dropdowns.fields = this.dropdowns.data.Properties.filter(
            (x) => x.Section == key
        );
    }

    list() {
        let callId = parseInt(this.$store.state.dashboard.componentId);

        return this.$services.callChecklist.get(callId).then((data) => {
            this.checklist = data;
        });
    }

    // Show edit
    addItem(action, childAction, parentIndex) {
        this.action = action;
        this.currentAction = 'Add';
        this.isChildAction = childAction;
        this.parentIndex = parentIndex;
        this.editedItem = {};
        this.dialog = true;
    }

    editSection(item) {
        this.action = this.actionType.Edit;
        this.currentAction = 'Update';
        this.isChildAction = false;
        this.editedIndex = this.checklist.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
    }

    editItem(parent, item) {
        this.action = this.actionType.Edit;
        this.currentAction = 'Update';
        this.isChildAction = true;
        this.parentSection = parent;
        this.editedIndex = this.parentSection.Items.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
    }

    deleteSection(item, action, childAction) {
        this.action = action;
        this.isChildAction = childAction;
        this.editedIndex = this.checklist.indexOf(item);
        this.editedItem = item;
        this.confirmText = this.$t("Are you sure you want to delete this record?").toString();
        this.confirmDialog = true;
    }

    deleteChecklist(section, item) {
        this.action = this.actionType.Delete;
        this.isChildAction = true;
        this.parentSection = section;
        this.editedItem = item;
        this.confirmText = this.$t("Are you sure you want to delete this record?").toString();
        this.confirmDialog = true;

    }

    confirmAction() {
        if (this.action === this.actionType.Delete) {

            if (this.isChildAction) {
                var index = this.parentSection.Items.indexOf(this.editedItem);
                if (index > -1)
                    this.parentSection.Items.splice(index, 1);
            } else {
                var index = this.checklist.indexOf(this.editedItem);
                if (index > -1)
                    this.checklist.splice(index, 1);
            }
        }

        this.confirmDialog = false;
    }

    clearFields() {
        this.editedItem = {};
    }

    addToLocal() {
        let errors: Array<string> = this.validate();
        if (errors.length > 0) {
            let message = "";
            let regEx = new RegExp('\{(.*?)\}');

            errors.forEach(element => {
                let key = element;
                let position = element.indexOf("{");

                if (position > 0)
                    key = element.substring(0, position);

                message += this.$t(key).toString().replace(regEx, element.match(regEx)[1]) + "<br />";
            });

            this.$store.commit(
                "application/setNotification",
                new Notification({
                    snack: true,
                    isHtml: true,
                    text: message,
                    color: "error"
                } as INotification),
                { root: true });
            this.resetKey += 1;
            return;
        }

        if (this.action == this.actionType.Add) {
            if (this.isChildAction) {
                this.editedItem["Type"] = "Checklist";
                this.checklist[this.parentIndex]["Items"].push(this.editedItem);
            } else {
                this.editedItem["Items"] = [];
                this.checklist.push(this.editedItem);
            }
        } else if (this.action == this.actionType.Edit) {
            if (this.isChildAction) {
                this.editedItem["Type"] = "Checklist";
                this.parentSection["Items"][this.editedIndex] = this.editedItem;
            } else {
                this.checklist[this.editedIndex] = this.editedItem;
            }
        }

        this.resetKey += 1;
        this.dialog = false;
        this.clearFields();
    }

    save() {
        // Set call id
        this.editedItem.InitiativeCallId = isNaN(this.$store.state.dashboard.componentId)
            ? -1
            : parseInt(this.$store.state.dashboard.componentId);

        this.$services.callChecklist.update(this.editedItem.InitiativeCallId, this.checklist).then((resp: any) => {
            if (resp instanceof Error) {
                this.$store.commit(
                    "application/setNotification",
                    new Notification({
                        snack: true,
                        isHtml: true,
                        text: this.$t("Error occurred."),
                        color: "error",
                    } as INotification),
                    { root: true });
            } else {
                this.clearFields();
                this.$store.commit(
                    "application/setNotification",
                    new Notification({
                        snack: true,
                        isHtml: true,
                        text: this.$t("Record updated successfully."),
                        color: "success",
                    } as INotification),
                    { root: true });
            }
        });
    }

    validate(): Array<string> {
        let errors: Array<string> = [];

        if (!this.editedItem.Title) {
            errors.push(this.$t("isRequired{Name (English)}").toString());
        }

        if (!this.isChildAction && !this.editedItem.Widget) {
            errors.push(this.$t("isRequired{Widget}").toString());
        }

        if (this.isChildAction && !this.editedItem.Field) {
            errors.push(this.$t("isRequired{Field}").toString());
        }

        return errors;
    }
};
